import Dashboard from "./pages/Dashboard";
import Loginform from "./pages/Loginform";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React from 'react'
import { Toaster } from 'sonner';
import ProtectedRoute from "./components/protectedRouteing/protectedRoute";

const App = () => {
  const LoggedIn = localStorage.getItem("UserLoggedIn");
  return (
    <>
      <Toaster richColors position="top-right" />
      <Router>
        <Routes>
          {/* unautherize routes */}
          {LoggedIn 
            ?<></>
            : <Route path="/" element={<Loginform title="Sign in to your Account" />} />
          }
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navigate to={"/dashboard"} />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
          </Route>
          <Route path={'/*'} element={<Navigate to={"/dashboard"}/>} />
        </Routes>
      </Router>
      </>
  )
}
export default App